import wix from './wix';

export const getLinguistParams = () => {
  const locale = window.__SITE_LANGUAGE__;
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang') || locale;
  const dateNumberFormat =
    urlParams.get('dateNumberFormat') || urlParams.get('locale') || locale;
  const isPrimaryLanguage = urlParams.get('isPrimaryLanguage') !== 'false';

  return { lang, dateNumberFormat, isPrimaryLanguage };
};

export const linguistHeader = () => {
  const instanceId = wix.getInstanceId();
  const { lang, dateNumberFormat, isPrimaryLanguage } = getLinguistParams();

  const header = [lang, dateNumberFormat, isPrimaryLanguage, instanceId].join(
    '|',
  );

  return { 'x-wix-linguist': header };
};
